import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientPrescriptionApi } from '../api/patientprescription.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientPrescriptionData, PatientPrescription } from '../../../interfaces/masters/patientprescription' ;
@Injectable()
export class PatientPrescriptionService extends PatientPrescriptionData {

    constructor(private api: PatientPrescriptionApi) {
      super();
    }
  
  
    list(url: string): Observable<PatientPrescription[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<PatientPrescription>{
        return this.api.getById(url);
    }
  
    create(url: string, data:PatientPrescription): Observable<PatientPrescription[]> {
      return this.api.add(url,data);
    }

    settingscreate(url: string, data:any): Observable<any> {
      return this.api.settingscreate(url,data);
    }
  
    update(url: string, data:PatientPrescription): Observable<PatientPrescription> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  